import { useState } from 'react';
import { SHA512 } from 'crypto-js';
import { commonQueries, usePersistStore } from '../lib/store';

function getNowDate(date = new Date()): string {
    const year = date.getFullYear(); // 연도 4자리
    const month = String(date.getMonth() + 1) // 월 (0~11이므로 +1)
        .padStart(2, '0'); // 두 자리 맞춤
    const day = String(date.getDate()) // 일자
        .padStart(2, '0'); // 두 자리 맞춤

    return `${year}${month}${day}`;
}

function addMonthsAndFormat(dateStr: string, months: number): string {
    const d = new Date(dateStr);
    d.setMonth(d.getMonth() + months);
    const YYYY = d.getFullYear().toString();
    const MM = String(d.getMonth() + 1).padStart(2, '0');
    const DD = String(d.getDate()).padStart(2, '0');
    return `${YYYY}${MM}${DD}`;
}

export const generateLicenseKey = (license: string, currentTimestamp: number): string => {
    return SHA512(`${license}/${currentTimestamp}`).toString();
};

interface UseCreateShortUrlOptions {
    shareUrl: string;
    startDate: string; // "YYYY-MM-DD"
    endDate: string; // "YYYY-MM-DD"
}

export function useCreateShortUrl({ shareUrl, startDate, endDate }: UseCreateShortUrlOptions) {
    const [shortUrl, setShortUrl] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const { mutate: urlTokenMutate } = commonQueries.postGetShortUrlToken();
    const { mutate: urlMutate } = commonQueries.postGetShortUrl();
    const { sUserId } = usePersistStore();

    const getUrlToken = async () => {
        setIsLoading(true);
        const key = await generateLicenseKey(
            import.meta.env.VITE_SHORT_URL_LICENSE_KEY,
            currentTimestamp
        );
        await urlTokenMutate(
            {
                serviceName: 'sbank',
                encLicense: key,
                currentTimestamp: currentTimestamp,
            },
            {
                onSuccess: (res) => {
                    if (res?.data?.result?.token?.accessToken) {
                        urlMutate(
                            {
                                url: shareUrl,
                                type: 1,
                                startDate: getNowDate(),
                                endDate: endDate ? addMonthsAndFormat(endDate, 3) : '',
                                accessToken: res?.data?.result?.token?.accessToken?.accessToken,
                                userId: sUserId,
                            },
                            {
                                onSuccess: (urlRes) => {
                                    setShortUrl(urlRes.data.result?.shortUrl);
                                },
                                onError: (err) => {
                                    setShortUrl(shareUrl);
                                    setError(err);
                                },
                            }
                        );
                    }
                },
            }
        );
        setIsLoading(false);
    };

    return { shortUrl, error, isLoading, getUrlToken };
}
